import * as React from 'react';
import { PractitionerOrOrganization } from '../../../../../../interfaces/interfaces';
import infoWindowModule from './infoWindowModule';

interface MarkerWithInfoWindowProps extends google.maps.MarkerOptions {
  item: PractitionerOrOrganization;
}

const MarkerWithInfoWindow = (options: MarkerWithInfoWindowProps) => {
  const [marker, setMarker] = React.useState<google.maps.Marker>();
  const svgMarker: google.maps.Symbol = {
    path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
    fillColor: 'red',
    fillOpacity: 1,
    strokeWeight: 0.2,
    rotation: 0,
    scale: 2.2,
    anchor: new google.maps.Point(12, 24),
  };

  const {
    item: { id },
  } = options;
  const { item, map } = options;

  const {
    infoWindowHandlerForMousOverOrOut,
    infoWindowHandlerForCustomEvent,
    selectItemInSearchResult,
    deselectItemInSearchResult,
    scrollSelectedItemInSearchResult,
  } = infoWindowModule(item, map);

  React.useEffect(() => {
    if (!marker) {
      const markerNew = new google.maps.Marker({
        optimized: false,
        icon: null,
      });
      setMarker(markerNew);
    }
    return () => {
      if (marker) {
        marker.setMap(null);
      }
    };
  }, [marker]);

  React.useEffect(() => {
    if (marker) {
      marker.setOptions(options);
    }
  }, [marker, options]);

  React.useEffect(() => {
    if (marker) {
      document.addEventListener(id, infoWindowHandlerForCustomEvent(marker, svgMarker));
      marker.addListener('mouseover', infoWindowHandlerForMousOverOrOut('open', marker));
      marker.addListener('mouseover', selectItemInSearchResult(id));
      marker.addListener('mouseout', infoWindowHandlerForMousOverOrOut('close', marker));
      marker.addListener('mouseout', deselectItemInSearchResult(id));
      marker.addListener('click', scrollSelectedItemInSearchResult(id));
    }
    return () => {
      if (marker) {
        document.removeEventListener(id, infoWindowHandlerForCustomEvent(marker, svgMarker));
      }
    };
  }, [marker, id]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default MarkerWithInfoWindow;
